import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";

const BrandPageGridCarouselsPage = withCompass(
  () =>
    import(
      "@faire/prototype-playground/workspace/bg/brand-page-grid-carousels/Page"
    )
);
const BrandPageNavXpPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/bg/brand-page-nav-xp/Page")
);
const BrandPageReviewsInGridPage = withCompass(
  () =>
    import(
      "@faire/prototype-playground/workspace/bg/brand-page-reviews-in-grid/Page"
    )
);
const CartSaveForLaterPage = withCompass(
  () => import("../../pages/CartSaveForLaterPage")
);
const SidecartSavedForLaterPage = withCompass(
  () => import("../../pages/SidecartSavedForLaterPage")
);

export function BronwynGemmillRoutes() {
  return (
    <Switch>
      <Route
        path="/bg/brand-page-grid-carousels"
        component={BrandPageGridCarouselsPage}
      />
      <Route path="/bg/brand-page-nav-xp" component={BrandPageNavXpPage} />
      <Route
        path="/bg/brand-page-reviews-in-grid"
        component={BrandPageReviewsInGridPage}
      />
      <Route
        path="/bg/sidecart-saved-for-later"
        component={SidecartSavedForLaterPage}
      />
      <Route path="/bg/cart-save-for-later" component={CartSaveForLaterPage} />
    </Switch>
  );
}

export const slug = "bg";
